import Page500 from 'components/@common/Page500/Page500';
import Page404 from 'components/@common/Page404/Page404';
import ExternalLink from 'containers/ExternalLink';
import LetterNumberFormations from 'containers/LetterNumberFormations';
import WoodPieces from 'containers/WoodPieces';
import WetDryTry from 'containers/WetDryTry';
import WorksheetMaker from 'containers/WorksheetMaker';
import Workbook from 'containers/Workbook';
import Resources from 'containers/Resources/Resources';
import Support from 'containers/Support/Support';
import Home from 'containers/Home';
import LessonPlanner from 'containers/LessonPlanner/LessonPlanner';
import AssignmentTracker from 'containers/AssignmentTracker/AssignmentTracker';
import LessonAssignment from 'containers/LessonAssignment';
import OptimalExperiencePage from 'components/Setup/OptimalExperiencePage/OptimalExperiencePage';

const rootRoutes = [
  {
    path: '/oops',
    component: Page500
  },
  {
    path: '/404',
    component: Page404
  },
  {
    path: '/device',
    component: OptimalExperiencePage,
    withMainLayout: false
  },
  {
    path: '/ext/:bookCode/:edition/:pageNumber?',
    component: ExternalLink,
    withMainLayout: false
  },
  {
    path: '/EXT/:bookCode/:edition/:pageNumber?',
    component: ExternalLink,
    withMainLayout: false
  },
  {
    path: '/books/:bookCode/:edition/support/:section?',
    component: Support,
    withMainLayout: true,
    getTitle: () => 'support',
    translationKey: 'nav'
  },
  {
    path: '/books/:bookCode/:edition/resources/:section?',
    component: Resources,
    withMainLayout: true,
    getTitle: () => 'title',
    translationKey: 'resources'
  },
  {
    path: '/apps/letter-number-formations/:bookCode/:edition',
    component: LetterNumberFormations,
    withMainLayout: true,
    getTitle: () => 'letterFormation',
    translationKey: 'apps'
  },
  {
    path: '/apps/wood-pieces/:bookCode/:edition',
    component: WoodPieces,
    withMainLayout: true,
    getTitle: () => 'woodPieces',
    translationKey: 'apps'
  },
  {
    path: '/apps/wet-dry-try/:bookCode/:edition',
    component: WetDryTry,
    withMainLayout: true,
    getTitle: () => 'wdt',
    translationKey: 'apps'
  },
  {
    path: '/apps/worksheet-maker/:bookCode/:edition',
    component: WorksheetMaker,
    withMainLayout: true,
    getTitle: () => 'worksheetMaker',
    translationKey: 'apps'
  },
  {
    path: '/books/:bookCode/:edition/lesson-planner',
    component: LessonPlanner,
    withMainLayout: false,
    getTitle: () => 'title',
    translationKey: 'lessonPlanner'
  },
  {
    path: '/books/:bookCode/:edition/lesson-planner/view',
    component: LessonPlanner,
    withMainLayout: true,
    getTitle: () => 'title',
    translationKey: 'lessonPlanner'
  },
  {
    path: '/books/:bookCode/:edition/assignment-tracker/:assignment?/:assignmentId?/:students?/:studentId?',
    component: AssignmentTracker,
    withMainLayout: true,
    getTitle: () => 'pageTitle',
    translationKey: 'assignmentTracker'
  },
  {
    path: '/books/:bookCode/:edition/lesson-planner/manage-options',
    component: LessonPlanner,
    withMainLayout: true,
    getTitle: () => 'manageOptions',
    translationKey: 'lessonPlanner'
  },
  {
    path: '/books/:bookCode/:edition/:pageNumber?/:isZoom?',
    component: Workbook,
    withMainLayout: true,
    getTitle: () => 'studentWorkbook',
    translationKey: 'nav',
    allowFullScreen: true,
    isBook: true
  },
  {
    path: '/teachers-guide/:bookCode/:edition/:pageNumber?/:isZoom?',
    component: Workbook,
    withMainLayout: true,
    getTitle: () => 'teachersGuide',
    translationKey: 'nav',
    allowFullScreen: true,
    isBook: true
  },
  {
    path: '/home/:bookCode?/:edition?',
    component: Home,
    withMainLayout: true,
    getTitle: () => 'title',
    translationKey: 'home'
  },
  {
    path: '/lesson-assignment/:bookCode/:edition/:productCurriculumId/:epochTime',
    component: LessonAssignment,
    withMainLayout: true,
    getTitle: () => 'assignLesson',
    translationKey: 'lessonPlanner'
  }
];

export default rootRoutes;
